import React, { useEffect, useState } from "react";
import { Form, Input, Button, message } from "antd";
import axios from "axios";

const ContactForm = ({ formData, setFormData, closeModal, refetchData }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (formData) {
      form.setFieldsValue(formData); // ✅ Set form values when editing
    } else {
      form.resetFields(); // ✅ Clear form when adding new contact info
    }
  }, [formData]);

  const onFinish = async (values) => {
    try {
      setLoading(true);

      if (formData?.id) {
        // ✅ Update Contact Info
        await axios.put(`http://93.127.203.113:5005/contactInfo/${formData.id}`, values);
        message.success("Contact information updated successfully.");
      } else {
        // ✅ Create New Contact Info
        await axios.post("http://93.127.203.113:5005/contactInfo", values);
        message.success("Contact information added successfully.");
      }

      refetchData();
      closeModal();
    } catch (error) {
      message.error("Failed to save contact information.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form form={form} onFinish={onFinish} layout="vertical">
      <Form.Item label="Title" name="title" rules={[{ required: true, message: "Title is required." }]}>
        <Input />
      </Form.Item>
      <Form.Item label="Description" name="description" rules={[{ required: true, message: "Description is required." }]}>
        <Input.TextArea rows={4} />
      </Form.Item>
      <Form.Item label="Phone" name="phone" rules={[{ required: true, message: "Phone is required." }]}>
        <Input />
      </Form.Item>
      <Form.Item label="Email" name="email" rules={[{ required: true, message: "Email is required." }]}>
        <Input />
      </Form.Item>
      <Form.Item label="Location" name="location" rules={[{ required: true, message: "Location is required." }]}>
        <Input />
      </Form.Item>

      <Button type="primary" htmlType="submit" loading={loading} style={{ backgroundColor: "#0c8c49", borderColor: "#0c8c49" }}>
        Save
      </Button>
    </Form>
  );
};

export default ContactForm;
